// Behavior-level. No concurrency internals or store-API specifics.

export default {
  title: 'App Category Segmenter',
  summary:
    "Paste a list of iOS or Android bundle IDs and the tool fetches each app's store category and groups them into segments — with a distribution view and CSV export.",

  sections: [
    {
      h: 'What this tool does',
      p: [
        "Looks up each bundle's category from the store and buckets the apps into category segments.",
        'It shows a distribution (which categories dominate your list), a per-segment app table, and a separate list of any IDs that failed to resolve.',
      ],
    },
    {
      h: 'When to use it',
      list: [
        "You've got a list of bundles and need to understand the category mix — for brand safety, contextual targeting, or reporting.",
        'You want a quick read on whether an inventory list skews toward, say, games versus news.',
      ],
    },
    {
      h: 'How to use it',
      steps: [
        '**Paste bundle IDs** (iOS or Android), one per line.',
        '**Pick a concurrency** if you want to trade speed for stability on large lists — the recommended setting is fine for most.',
        '**Run, then read the distribution** and expand any segment to see its apps.',
        '**Export to CSV** for the full categorized list, including the IDs that failed.',
      ],
    },
    {
      callout:
        "Categories come from each app's store listing, so they're only as granular as the store's own taxonomy. An app can carry more than one category — the segment uses its primary one.",
    },
  ],

  faqs: [
    {
      q: 'Some IDs failed.',
      a: "A failed lookup means the store didn't return that app — removed, region-locked, or a bad ID. They're listed separately so your segments stay clean.",
    },
    {
      q: 'Why a concurrency setting?',
      a: 'Higher concurrency is faster but more likely to hit store rate limits on big lists. The recommended setting balances the two.',
    },
  ],
};
